export default __webpack_public_path__ + "static/media/hamtri.cecf36d4.png";